import { PageHeader } from '@/shared/components/PageHeader';
import { Loader2, ShieldCheck } from 'lucide-react';
import { RoleEditView } from '../components/RoleEditView';
import { useRoleData } from '../hooks/useRoleData';

export function RoleEditPage() {
  const { roleId, isEdit, role, subjects, subjectsLoading } = useRoleData();

  // Hold the form back until its data is ready: an edited role must be loaded so its fields and
  // matrix can't flash, and the subject list must be loaded so the matrix's open-state (an
  // uncontrolled Radix `defaultValue`, captured once at mount) is computed against real groups.
  if ((isEdit && !role) || subjectsLoading) {
    return (
      <div className="h-full flex flex-col overflow-hidden">
        <PageHeader
          title="Role Management"
          subtitle="Edit role"
          icon={<ShieldCheck className="w-7 h-7" style={{ color: '#E84A2B' }} />}
        />
        <div role="status" className="flex flex-1 items-center justify-center">
          <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
          <span className="sr-only">Loading role…</span>
        </div>
      </div>
    );
  }

  // Key by role id: navigating to a different role remounts the form with fresh initial state.
  return (
    <RoleEditView
      key={roleId ?? 'new'}
      roleId={roleId}
      isEdit={isEdit}
      role={role}
      subjects={subjects}
    />
  );
}
